import {sortBy, without} from 'lodash';
import React, {Component} from 'react';

import {
  BannerCreator,
  BannerDefinition,
  BannersApiContext,
  BannersApiContextProps,
  BannersListContext,
} from './bannersContext';

/*
 * Component.
 */

interface BannersProviderState {
  banners: ReadonlyArray<BannerDefinition>;
}

export class BannersProvider extends Component<{}, BannersProviderState> {
  constructor(props: {}) {
    super(props);
    this.state = {banners: []};
    this.apiContext = {createBanner: this.createBanner};
  }

  private readonly apiContext: BannersApiContextProps;

  private readonly createBanner: BannerCreator = (banner) => {
    // Add the new layer to the state.
    this.setState(({banners}) => ({banners: sortBanners([banner, ...banners])}));

    // Return a method to remove it later.
    return () => {
      saveNode(banner.node);
      this.setState(({banners}) => ({banners: without(banners, banner)}));
    };
  };

  render() {
    return (
      <BannersApiContext.Provider value={this.apiContext}>
        <BannersListContext.Provider value={this.state.banners}>
          {this.props.children}
        </BannersListContext.Provider>
      </BannersApiContext.Provider>
    );
  }
}

/*
 * Helpers.
 */

/**
 * The portals will clear their content right away.
 * We save it so that the animation can complete.
 */
function saveNode(node: HTMLElement) {
  const {parentElement} = node;
  if (!parentElement) {
    return;
  }

  const nodeClone = node.cloneNode(true);
  parentElement.appendChild(nodeClone);
  parentElement.removeChild(node);
}

function sortBanners(banners: ReadonlyArray<BannerDefinition>) {
  return sortBy(banners, (b) => b.priority);
}
